import {Geolocation as GeolocationHardware} from "@ionic-native/geolocation";
import React from "react";
import {IonButton, IonIcon, IonLoading} from "@ionic/react";
import GPSCoordinates from "../../models/GPSCoordinates";
import Error from "../utils/alert/error/Error";
import {locate} from "ionicons/icons";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Function called when the device is located.
     * @param {GPSCoordinates} geolocation Object containing the user's new location.
     */
    onLocate: (geolocation: GPSCoordinates) => void,
}

/**
 * Component allowing the geolocation of the user.
 * @author Alizée Grand
 * @version 1.2
 * @creation 28/03/2022
 * @last_update 11/07/2022
 **/
class GeolocateDevice extends React.Component<Props> {

    state = {
        isGeolocError: false,
        isLoadingOpen: false,
    }

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        /**
         * Display or not the loading screen
         * @param visibility
         */
        const displayOrNotLoading = (visibility: boolean) => {
            this.setState({isLoadingOpen: visibility});
        }

        /**
         * Retrieves GPS coordinates and stores them asynchronously in the parent
         */
        const getLocation = async () => {
            displayOrNotLoading(true);
            GeolocationHardware.getCurrentPosition({enableHighAccuracy: true})
                .then((position) => {
                    const tempLatitude = position.coords.latitude;
                    const tempLongitude = position.coords.longitude;
                    if (GPSCoordinates.isLatValid(tempLatitude) && GPSCoordinates.isLongValid(tempLongitude)) {
                        this.setState({isGeolocError: false});
                        this.props.onLocate(new GPSCoordinates(tempLatitude, tempLongitude));
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({isGeolocError: true});
                })
                .finally(() => {
                    displayOrNotLoading(false);
                })
            ;
        }

        return (
            <div>
                {
                    this.state.isGeolocError ? (
                        <Error>
                            {getTranslation("hardware.geolocate.error")}
                        </Error>
                    ) : ""
                }
                <IonButton
                    expand="block"
                    size="large"
                    color="primary"
                    onClick={getLocation}
                >
                    {getTranslation("hardware.geolocate.button-title")}
                    <IonIcon icon={locate} slot="end"/>
                </IonButton>

                <IonLoading
                    isOpen={this.state.isLoadingOpen}
                    message={getTranslation("utils.loading.message")}
                    spinner={'bubbles'}
                />
            </div>
        );
    };

}

export default withTranslation()(GeolocateDevice);
